import type { Theme } from "../tokens";

/** The dark mode people actually leave on, with one off-key note. */
export const nocturne: Theme = {
  id: "nocturne",
  name: "Nocturne",
  thesis: "The dark mode people actually leave on, with one off-key note.",
  scheme: "dark",
  colors: {
    ground: "#14181D",
    surface: "#1B2027",
    raised: "#232A33",
    ink: "#DDE3EA",
    dim: "#8D97A5",
    rule: "#2A323C",
    lattice: "#222932",
    focus: "#7FD1AE",
    inbox: "#7FD1AE",
    feed: "#7C8AA5",
    paperTrail: "#808A96",
    screener: "#D8A34A",
  },
  type: {
    sans: "'Public Sans', system-ui, sans-serif",
    mono: "'Public Sans', system-ui, sans-serif",
    googleFonts: "Public+Sans:wght@400;500;700",
    tracking: "0",
  },
  density: {
    row: 52,
    primary: 15,
    secondary: 14,
    meta: 12,
    listWidth: 780,
    rail: 212,
    radius: 8,
    lineHeight: 1.5,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
